import React, { createContext, useEffect, useState } from "react";
// import { graphConfig, loginRequest, msalConfig }

import {
  EventType,
  InteractionRequiredAuthError,
  PublicClientApplication,
} from "@azure/msal-browser";
import config, { loginRequest, msalConfig } from "../../config/authConfig";
import CryptoJS from "crypto-js";

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.addEventCallback(
  (event) => {
    // set active account after redirect
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
      const account = event.payload.account;
      msalInstance.setActiveAccount(account);
    }
  },
  (error) => {
    console.log("error", error);
  }
);

export const msalContext = createContext({});

const Auth = (prop) => {
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(false);
  const [msal, setMsal] = useState();

  useEffect(() => {
    const handleAuth = async () => {
      try {
        const res = await msalInstance.handleRedirectPromise();
        let account;
        if (res) {
          //if you are already logged in, get the cached account
          account = res.account;
        } else {
          // In case multiple accounts exist, you can select
          const currentAccounts = msalInstance.getAllAccounts();

          if (currentAccounts.length === 0) {
            // no accounts signed-in, attempt to sign a user in
            msalInstance.loginRedirect(loginRequest);
          } else if (currentAccounts.length > 1) {
            // Add choose account code here
            account = currentAccounts[0];
          } else if (currentAccounts.length === 1) {
            account = currentAccounts[0];
          }
        }

        const accessTokenRequest = {
          account,
          scopes: loginRequest.scopes,
        };
        try {
          // console.log({ account });
          // Display signed-in user content, call API, etc.

          const tokenRes =
            await msalInstance.acquireTokenSilent(accessTokenRequest);
          const wwid = tokenRes.account.idTokenClaims.employeeId || "";
          // const email =
          //   tokenRes?.account?.idTokenClaims?.preferred_username || "";
          // const name = tokenRes?.account?.idTokenClaims?.name || "";
          const secretKeyforEncryption = config.encryptionkey;
          const lsWWID_enc = CryptoJS.AES.encrypt(wwid, secretKeyforEncryption);
          localStorage.setItem("wwid", lsWWID_enc);
          setIsUserAuthenticated(true);
          setMsal(msalInstance);

          // me endpoint
          // const accessToken = res.accessToken
          // fetch(graphConfig.graphMeEndpoint, {
          //   method: "GET",
          //   headers: {
          //     "Content-Type": "application/json",
          //     Authorization: `Bearer ${accessToken}`,
          //   },
          // })
          //   .then((user) => user.json())
          //   .then((user1) => {
          //     console.log({ user1 });
          //   })
          //   .catch((err) => {
          //     console.log({ err });
          //   });
        } catch (error) {
          //Acquire token silent failure, and send an interactive request
          console.log(error);
          if (error instanceof InteractionRequiredAuthError) {
            msalInstance.acquireTokenRedirect(accessTokenRequest);
          }
        }
      } catch (err) {
        console.log({ err });
      }

      // msalInstance.logoutRedirect(logoutRequest);
    };
    handleAuth();
  }, []);

  return (
    <div>
      {isUserAuthenticated && (
        <msalContext.Provider value={msal}>
          {prop.children}
        </msalContext.Provider>
      )}
    </div>
  );
};

export default Auth;
